import { getSettingsAll } from "@/api/generated/BMWApi"
import { useEffect, useState } from "react"

const usePrivacyPolicyLink = (): string => {
  const [privacyPolicyLink, setPrivacyPolicyLink] = useState<string | null>(null)

  useEffect(() => {
    const fetchSettings = async (): Promise<void> => {
      try {
        const response = await getSettingsAll()
        // Assuming the API returns an array of settings
        // and the privacy policy URL is in one of the objects.
        // You might need to adjust this logic based on the actual API response structure.
        const privacyPolicySetting = response.data.body?.find(
          (setting) => setting.key === "PolicyLink",
        )

        if (privacyPolicySetting) {
          setPrivacyPolicyLink(privacyPolicySetting.value)
        } else {
          console.warn("Privacy Policy Link not found in settings.")
          setPrivacyPolicyLink("") // Fallback URL
        }
      } catch (error) {
        console.error("Failed to fetch settings:", error)
        setPrivacyPolicyLink("") // Fallback URL
      }
    }

    fetchSettings()
  }, [])

  return privacyPolicyLink || ""
}

export default usePrivacyPolicyLink
